/*
    JS utile sur toutes les pages
 */
$(function () {
    /*
        Menu au hover sur desktop
        Le code est un peu plus compliqué pour ne pas avoir de "saut" lorsqu'on passe de la nav au menu
     */
    $('#mainNav li a[data-target]')
        .on('mouseenter', function () {
            var $this = $(this);
            $this.addClass('active');
            $($this.attr('data-target')).addClass('open');
        })
        .on('mouseleave', function () {
            var $this = $(this);
            $this.removeClass('active');
            $($this.attr('data-target')).removeClass('open');
        })
    ;
    $('#mainMenu .menu')
        .on('mouseenter', function () {
            var $this = $(this);
            $('#mainNav li a[data-target="#' + $this.attr('id') + '"]').addClass('active');
            $this.addClass('open');
        })
        .on('mouseleave', function () {
            var $this = $(this);
            $('#mainNav li a[data-target="#' + $this.attr('id') + '"]').removeClass('active');
            $this.removeClass('open');
        })
    ;

    /*
        Menu au "touch" pour tablette
     */
    $('#mainNav li a[data-target]')
        .on('touchstart', function () {
            var $this = $(this);

            $this.toggleClass('active');
            $($this.attr('data-target')).toggleClass('open');
        })
    ;

    /*
        Datepicker JS
        A cause de ce bug: https://github.com/uxsolutions/bootstrap-datepicker/issues/1971
        On ne peut pas utiliser l'option "disableTouchKeyboard"
        Alors on a notre propre code sur l'évènement show
     */
    $('.input-group.date')
        .datepicker({
            assumeNearbyYear: true,
            autoclose: true,
            disableTouchKeyboard: true, // important pour mobile
            language: 'fr-CH',
            maxViewMode: 2,
            orientation: 'bottom', // sinon cela marche mal sur mobile
            todayBtn: 'linked',
            todayHighlight: true
        })
        .on('show', function (e) {
            if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document)) {
                $('.input-group.date input').blur();
            }
        })
    ;
    // Aussi pour des périodes
    $('.input-group.date-range')
        .datepicker({
            autoclose: true,
            disableTouchKeyboard: true, // important pour mobile
            language: 'fr-CH',
            maxViewMode: 2,
            orientation: 'bottom', // sinon cela marche mal sur mobile
            todayBtn: 'linked',
            todayHighlight: true
        })
        .on('show', function (e) {
            if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document)) {
                $('.input-group.date-range input').blur();
            }
        })
    ;

    /*
        Comportement exclusif sur les collapse des menus
        Bootstrap ne permet de faire cela de base que sur des .panel
     */
    if ($('[data-accordion="true"]')) {
        $('[data-accordion="true"] .collapse').on('show.bs.collapse', function () {
            var $this = $(this);

            if ($this.hasClass('in')) { /* permet d'exclure des sous-menus */
                return;
            }

            var parentSelector = $this.attr('data-parent');

            $this.parent(parentSelector).find('.collapse.in').collapse('hide');
        });
    }
});

const canLoadTurnstile = new Promise((resolve, reject) => {
    document.addEventListener('canLoadTurnstile', function () {
        console.log('[canLoadTurnstile] event received');
        resolve();
    });
})

const turnstileLoaded = new Promise((resolve, reject) => {
    window.onloadTurnstileCallback = function () {
        console.log('[onloadTurnstileCallback] event received');
        resolve();
    }
})

$(document).ready(function () {
    $.ajax({
        url: $('#mobile-menu-placeholder').data('url'),
        cache: true,
        success: function (data, status, xhr) {
            $('#mobile-menu-placeholder').replaceWith(data);

            // Activate the mobile menu once it is loaded
            $('#mobile-menu').mmenu({
                'offCanvas': {
                    'position': 'right'
                },
                'extensions': [
                    'border-full',
                    'multiline',
                    'theme-chuv'
                ],
                'navbars': [
                    {
                        'position': 'top',
                        'content': $('#main-search').length ? $('#main-search')[0].outerHTML : ''
                    },
                    {
                        'position': 'bottom',
                        'height': 2, // Pour notre CSS
                        'content': $('#socials').length ? $('#socials')[0].outerHTML : ''
                    }
                ]
            });

            // Always display "Retour" as title in the menu
            $('.mm-title[href]').text('Retour');

            // Check if the page has a turnstile element
            const hasTurnstileEl = document.querySelector('.cf-turnstile');
            if (hasTurnstileEl) {
                console.log('Dispatching canLoadTurnstile');
                document.dispatchEvent(new Event('canLoadTurnstile'));
            }
        }
    });

    // If the URL contains a hash, check if it points inside an accordion and open the panel if necessary
    if (window.document.location.hash !== '') {
        // Try to get the panel containing the element referenced by the hash
        let target = $(window.document.location.hash).parents('div[class*="collapse"]')
        // If the panel exists and it is not open, open it
        if (target.length > 0 && !target.hasClass('in')) {
            // Get the control and click it to open
            let control = $('a[href="#' + target.attr('id') + '"]')
            control.click()
            // Change the hash to point to the control, so that the title can be seen by the user
            window.document.location.hash = '#' + target.attr('id')
        }
    }
});


Promise.all([canLoadTurnstile, turnstileLoaded]).then((values) => {
    console.log("Received all promises (canLoadTurnstile, turnstileLoaded)");
    const turnstileEl = document.querySelector('.cf-turnstile');
    turnstile.render(turnstileEl, {
        sitekey: turnstileEl.dataset.sitekey,
        callback: function (token) {
            console.log(`Challenge Success ${token}`);
        },
    });
});
